import { Controller } from '@hotwired/stimulus';
import Rails from '@rails/ujs';

export default class extends Controller {
	static targets = ['form', 'input', 'input2', 'dateField']

	connect() {
		//console.log("started");	 
	}
	onPostSuccess (event) {
		console.log('success!');
	}

    update() {
		console.log("UPDATE");
		Rails.fire(this.formTarget, 'submit');
		// prevent default form submission
		event.preventDefault();
	}

	// Tickets 747 & 749: +/- steppers for weight and reps.
	// The step size comes from the button's data-step attribute (2.5 for weight, 1 for reps).
	increment(event) {
		this._step(event, 1);
	}

	decrement(event) {
		this._step(event, -1);
	}

	_step(event, direction) {
		event.preventDefault();
		const input = this.element.querySelector('input[type="number"]');
		if (!input) return;
		const step = parseFloat(event.currentTarget.dataset.step || input.step || "1");
		let current = parseFloat(String(input.value).replace(",", "."));
		if (isNaN(current)) current = 0;
		let next = current + direction * step;
		if (next < 0) next = 0; // No negative weights or reps
		// Guard against floating point artefacts (e.g. 7.5000000001)
		next = Math.round(next * 100) / 100;
		input.value = next;
		// Persist immediately via the same auto-save path as manual entry
		const form = input.closest("form") || (this.hasFormTarget ? this.formTarget : null);
		if (form) Rails.fire(form, "submit");
	}

	highlight(event) {
		// select everything in the input
		console.log("Selected!")
		if (this.hasInputTarget) {
			console.log(this.inputTarget);
			this.inputTarget.select();
		}
		// if input2 not null
		if (this.hasInput2Target) {
			console.log(this.input2Target);
		this.input2Target.select();
		}
		//event.stopImmediatePropagation();
	}

	clearDate(event) {
		console.log("Clear date called");
		
		// Find the closest button (could be the SVG path or the button itself)
		const button = event.target.closest('button');
		if (!button) {
			console.log("No button found");
			return;
		}
		
		// Find container div with dateField target
		const container = button.closest('[data-remoteform-target="dateField"]');
		if (!container) {
			console.log("No container found");
			return;
		}
		
		// Find the date/datetime input field
		const dateField = container.querySelector('input[type="date"], input[type="datetime-local"]');
		if (!dateField) {
			console.log("No date field found");
			return;
		}
		
		console.log("Clearing date field:", dateField);
		
		// Clear the date field
		dateField.value = "";
		
		// Trigger change event to ensure form validation is updated
		const changeEvent = new Event('change', { bubbles: true });
		dateField.dispatchEvent(changeEvent);
		
		// Submit form if it's in a form
		const form = dateField.closest('form');
		if (form) {
			console.log("Submitting form");
			Rails.fire(form, 'submit');
		} else {
			console.log("No form found");
		}
	}
}
